import { render } from "./invoicesConfig.vue?vue&type=template&id=033e7266&scoped=true"
import script from "./invoicesConfig.vue?vue&type=script&lang=js"
export * from "./invoicesConfig.vue?vue&type=script&lang=js"

import "./invoicesConfig.vue?vue&type=style&index=0&id=033e7266&scoped=true&lang=css"

import exportComponent from "/cwt/data/jenkins/workspace/RoomIt-HotelWeb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-033e7266"]])

export default __exports__